import NavigationBar from './Navbar';
import Hero from './Hero';
import About from './About';
import StatsLanding from './StatsLanding';
import CallToActionLanding from './CallToActionLanding';
import Footer from './Footer';
import './LandingPage.css'; // Use this CSS specifically for LandingPage

const LandingPage = () => {
  return (
    <main className="landing-page-container">
      <NavigationBar />

      <section id="home" className="landing-section">
        <Hero />
      </section>

      <section id="about" className="landing-section">
        <About />
      </section>
        
      <StatsLanding />

      <CallToActionLanding />

      <Footer />
    </main>
  );
};

export default LandingPage;
